import { useEffect, useState, useMemo, useCallback } from 'react';
import get from 'lodash.get';
import { getTeam } from './getTeam';
import { getPlayer } from './getPlayer';
const recursivelyPopulate = (spec, data) => {
    const isTemplateValue = typeof spec === 'string' ? spec[0] === '$' : false;
    const isArray = Array.isArray(spec);
    const isObject = !isArray && !null && typeof spec === 'object';
    const isStringLiteral = !isTemplateValue && typeof spec === 'string';
    const isNumberLiteral = typeof spec === 'number';
    const isNil = typeof spec === undefined || typeof spec === null;
    if (isNil) {
        return '';
    }
    if (isStringLiteral || isNumberLiteral) {
        return spec;
    }
    if (isTemplateValue) {
        const result = get(data, spec.slice(1).split('.'));
        return result;
    }
    if (isArray) {
        return spec.map((_, index) => recursivelyPopulate(spec[index], data));
    }
    if (isObject) {
        const val = {};
        Object.entries(spec).forEach(([key, value]) => {
            val[key] = recursivelyPopulate(spec[key], data);
        });
        return val;
    }
};
// Will auto populate entities when the following fields appear
// playerId, teamId, playerOneId, playerTwoId -> player, team, playerOne, playerTwo
export const updateGfxProps = (graphicProps, latestData) => {
    var _a, _b, _c, _d, _e;
    const match = latestData.match;
    if (!graphicProps || !match) {
        return graphicProps;
    }
    if (graphicProps.playerId) {
        graphicProps.player = getPlayer(graphicProps.playerId, match.lineup || []);
    }
    if (graphicProps.teamId) {
        graphicProps.team = getTeam(graphicProps.teamId, match.homeTeam, match.awayTeam);
    }
    // Ads url for a given adSetId and adSizes
    if (graphicProps.adSize && graphicProps.adSetId) {
        graphicProps.adUrl = (_e = (_d = [
            ...(_a = match.homeTeam.adAllocation) === null || _a === void 0 ? void 0 : _a.adSets,
            ...(_b = match.awayTeam.adAllocation) === null || _b === void 0 ? void 0 : _b.adSets,
            ...(_c = match.competition.adAllocation) === null || _c === void 0 ? void 0 : _c.adSets
        ]
            .find(({ id }) => {
            return id === graphicProps.adSetId;
        })) === null || _d === void 0 ? void 0 : _d.adFiles.find(({ size }) => {
            return size === graphicProps.adSize;
        })) === null || _e === void 0 ? void 0 : _e.file.url;
    }
    return graphicProps;
};
const populateData = (spec, data) => {
    const result = recursivelyPopulate(spec, data);
    return result;
};
export function useGraphicData(fieldDataSpec, graphicProps, canUpdate, latestData, triggerToGraphicData, returnEarly) {
    // ad graphicProps
    const data = useMemo(() => {
        var _a;
        return (Object.assign(Object.assign({}, latestData), { currentPeriodData: (_a = latestData.summary) === null || _a === void 0 ? void 0 : _a.periods.find(({ code }) => { var _a; return code === ((_a = latestData === null || latestData === void 0 ? void 0 : latestData.summary) === null || _a === void 0 ? void 0 : _a.currentPeriod); }), graphicProps: updateGfxProps(triggerToGraphicData ? triggerToGraphicData(latestData, graphicProps) : graphicProps, latestData) }));
    }, [graphicProps, latestData, triggerToGraphicData]);
    const getData = useCallback(() => {
        return populateData(fieldDataSpec, data);
    }, [fieldDataSpec, data]);
    const [lastData, setFieldData] = useState(getData());
    useEffect(() => {
        if (canUpdate) {
            const newData = getData();
            setFieldData(newData);
        }
    }, [getData, canUpdate]);
    if (canUpdate && returnEarly) {
        return getData();
    }
    return lastData;
}
//# sourceMappingURL=useGraphicData.js.map